var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9506 0.402662C15.0126 0.0992138 16.1196 0.714198 16.423 1.77627C16.4741 1.95495 16.5 2.13988 16.5 2.32571V3.99998H18.5C19.6046 3.99998 20.5 4.89541 20.5 5.99998V18C20.5 19.1045 19.6046 20 18.5 20H2.5C1.39543 20 0.5 19.1045 0.5 18H0.526703C0.508952 17.8924 0.5 17.7835 0.5 17.6742V5.75428C0.5 4.86132 1.09195 4.07655 1.95056 3.83123L13.9506 0.402662ZM8.64005 18H18.5V9.99998H16.5V14.2457C16.5 15.1386 15.908 15.9234 15.0494 16.1687L8.64005 18ZM16.5 5.99998H18.5V7.99998H16.5V5.99998ZM2.5 5.75426V17.6742L14.5 14.2457V2.32568L2.5 5.75426ZM12.5 7.99998C12.5 8.55227 12.0523 8.99998 11.5 8.99998C10.9477 8.99998 10.5 8.55227 10.5 7.99998C10.5 7.4477 10.9477 6.99998 11.5 6.99998C12.0523 6.99998 12.5 7.4477 12.5 7.99998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.92681a4f7e13883552a79fca091709c9.svg";
export { ForwardRef as ReactComponent };